import { Action } from '@ngrx/store';
import { DisplayType } from '@polaris-customerweb/sharedcomponents.core';

export const DisplayAction = {
    setDisplayType: '[display] set display type',
};

export class SetDisplayType implements Action {
    type = DisplayAction.setDisplayType;
    constructor(public displayType: DisplayType | undefined) {}
}
